;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { AppCenteredStatus } from '@workspace/ui/components/custom/app-centered-status';
import { Button } from '@workspace/ui/components/button';
import { TriangleAlert } from 'lucide-react';
import Link from 'next/link';

interface GeneralNotFoundPageProps {
  fillViewport?: boolean;
}

export function GeneralNotFoundPage({ fillViewport = false }: GeneralNotFoundPageProps) {
  return (
    <AppCenteredStatus
      fillViewport={fillViewport}
      icon={
        <TriangleAlert
          aria-hidden="true"
          className="size-[74px] stroke-2! text-orange-500 dark:text-orange-400"
        />
      }
      title="Page not found"
      description="You have entered the void. There is nothing here."
      actions={
        <Button asChild variant="primary" className="h-10 w-full text-sm">
          <Link href="/">
            <p>Go to homepage</p>
          </Link>
        </Button>
      }
    />
  );
}
